import { render, staticRenderFns } from "./UmanjeniSati.vue?vue&type=template&id=46837cba&scoped=true&"
import script from "./UmanjeniSati.vue?vue&type=script&lang=js&"
export * from "./UmanjeniSati.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46837cba",
  null
  
)

export default component.exports